import { render } from "./reportKitNameBillProfitDetails.vue?vue&type=template&id=2bc8e5df"
import script from "./reportKitNameBillProfitDetails.vue?vue&type=script&lang=js"
export * from "./reportKitNameBillProfitDetails.vue?vue&type=script&lang=js"

import "./reportKitNameBillProfitDetails.vue?vue&type=style&index=0&id=2bc8e5df&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__